import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const containerMarginCss = css({
  margin: '48px 0',
  [MediaQueries.mdAndUp]: {
    margin: '64px 0',
  },
});

export const headlineCss = css(typography.effra48, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  marginBottom: 52,
  [MediaQueries.mdAndUp]: {
    marginBottom: 64,
  },
});

export const languageCss = css({
  cursor: 'pointer',
  display: 'flex',
  marginBottom: 24,
  '&:hover, &:focus': {
    outline: `1px solid ${colorsPalette.teal}`,
  },
});
